export const formatAddress = (...args: (string | undefined | null)[]) => {
  const parts = args.filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : null;
};
